import React, { useState, useEffect } from "react";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";
import ProjectModal from "./ProjectModal"; 
import "./ProjectList.css"; 

const PAGE_SIZE = 10;

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await axiosClient.get(API_ENDPOINTS.projects);
      setProjects(res.data || []);
    } catch (error) {
      console.error("❌ Lỗi load Projects:", error);
    }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm("CẢNH BÁO: Bạn có chắc chắn muốn xóa TOÀN BỘ dự án không?")) return;
    try {
      await axiosClient.delete(`${API_ENDPOINTS.projects}/delete-all`);
      alert("Đã dọn dẹp sạch bảng dữ liệu!");
      fetchProjects();
      setCurrentPage(1);
    } catch (error) {
      alert("Xóa tất cả thất bại!");
    }
  };

  const handleExport = async () => {
    try {
      const response = await axiosClient.get(`${API_ENDPOINTS.projects}/export`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Projects_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      alert("Export thất bại!");
    }
  };

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      await axiosClient.post(`${API_ENDPOINTS.projects}/import`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Import thành công!");
      fetchProjects();
      e.target.value = null;
    } catch (error) {
      alert("Import thất bại!");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Xóa dự án này?")) return;
    try {
      await axiosClient.delete(`${API_ENDPOINTS.projects}/${id}`);
      fetchProjects();
    } catch (error) {
      console.error("Lỗi xóa:", error);
    }
  };

  const handleSave = async (data) => {
    try {
      if (editingProject) {
        await axiosClient.put(`${API_ENDPOINTS.projects}/${editingProject.id}`, data);
      } else {
        await axiosClient.post(API_ENDPOINTS.projects, data);
      }
      fetchProjects();
      setShowModal(false);
    } catch (error) {
      console.error("Lưu thất bại:", error);
      alert("Lỗi khi lưu dữ liệu!");
    }
  };

  const filteredData = projects.filter((p) => {
    return (
      (p.code || "").toLowerCase().includes(search.toLowerCase()) ||
      (p.name || "").toLowerCase().includes(search.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
  const currentData = filteredData.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  const thStyle = { backgroundColor: "#f8f9fc", color: "#4e73df", fontWeight: "bold", fontSize: "0.8rem", textTransform: "uppercase" };

  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <h5 className="m-0 font-weight-bold text-dark text-uppercase">Project Management</h5>
          
          <div className="d-flex gap-2 align-items-center">
            {/* Search Box */}
            <div className="position-relative">
               <input
                type="text"
                className="form-control form-control-sm ps-4"
                style={{ width: "220px", borderRadius: "20px" }}
                placeholder="Search projects..."
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <i className="fas fa-search position-absolute text-muted" style={{ left: "12px", top: "8px", fontSize: "12px" }}></i>
            </div>

            {/* Action Buttons */}
            <div className="btn-group shadow-sm" style={{ borderRadius: "8px", overflow: "hidden" }}>
              <button className="btn btn-sm btn-light border" onClick={handleExport} title="Export Excel">
                <i className="fas fa-file-export text-primary me-1"></i> Export
              </button>
              <label className="btn btn-sm btn-light border mb-0" style={{ cursor: "pointer" }} title="Import Excel">
                <i className="fas fa-file-import text-warning me-1"></i> Import 
                <input type="file" accept=".xlsx" hidden onChange={handleImport} />
              </label>
            </div>

            <button
              className="btn btn-sm btn-primary px-3 rounded-pill shadow-sm fw-bold"
              onClick={() => {
                setEditingProject(null);
                setShowModal(true);
              }}
            >
              <i className="fas fa-plus me-1"></i> Add New
            </button>

           
          </div>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th className="text-center" style={thStyle}>No.</th>
                  <th style={thStyle}>Project Code</th>
                  <th style={thStyle}>Project Name</th>
                  <th style={thStyle}>Description</th>
                  <th className="text-center" style={thStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((p, idx) => (
                    <tr key={p.id}>
                      <td className="text-center text-muted small">
                        {(currentPage - 1) * PAGE_SIZE + idx + 1}
                      </td>
                      <td>
                        <span className="badge bg-light text-primary border px-2 py-1">
                          {p.code}
                        </span>
                      </td>
                      <td className="fw-bold text-dark">{p.name}</td>
                      <td>
                        <div className="text-muted small" style={{ maxWidth: "300px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={p.description}>
                          {p.description || "---"}
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <button
                            className="btn btn-sm btn-outline-primary border-0 rounded-circle shadow-sm"
                            style={{ width: "32px", height: "32px", padding: "0" }}
                            onClick={() => {
                              setEditingProject(p);
                              setShowModal(true);
                            }}
                            title="Edit"
                          >
                            <i className="fas fa-pencil-alt"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger border-0 rounded-circle shadow-sm"
                            style={{ width: "32px", height: "32px", padding: "0" }}
                            onClick={() => handleDelete(p.id)}
                            title="Delete"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5 text-muted">
                      <i className="fas fa-folder-open d-block mb-2 fa-2x"></i>
                      No projects found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center p-3 bg-light border-top">
            <span className="small text-muted fw-bold">
              Showing page {currentPage} of {totalPages || 1}
            </span>
            <nav>
              <ul className="pagination pagination-sm mb-0">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link border-0 shadow-sm mx-1 rounded-circle" onClick={() => setCurrentPage(currentPage - 1)}>
                    <i className="fas fa-chevron-left"></i>
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                    <button 
                      className={`page-link border-0 shadow-sm mx-1 rounded-circle ${currentPage === i + 1 ? "bg-primary text-white" : "bg-white text-dark"}`} 
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link border-0 shadow-sm mx-1 rounded-circle" onClick={() => setCurrentPage(currentPage + 1)}>
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {showModal && (
        <ProjectModal
          show={showModal}
          initialData={editingProject}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default ProjectList;